import React from 'react';
import PropTypes from 'prop-types';

/**
 * Card - A simple HTML replacement for Bloomer's Card component
 * Uses the same class names as Bloomer for perfect CSS compatibility
 *
 * Note: When using tag="form", make sure this component is not nested inside another form
 * to avoid React DOM nesting validation errors.
 */
export function Card({
  isFullWidth = false,
  className = '',
  children = null,
  tag: Tag = 'div',
  ...rest
}) {
  // Build the class name string based on props
  let classNames = 'card';

  if (isFullWidth) {
    classNames += ' is-fullwidth';
  }

  if (className) {
    classNames += ` ${className}`;
  }

  // The key prop is automatically handled by React's spread operator
  // and doesn't need special handling in the component
  return (
    <Tag className={classNames} {...rest}>
      {children}
    </Tag>
  );
}

// eslint-disable-next-line react/require-default-props
Card.propTypes = {
  isFullWidth: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node,
  tag: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
};

export default Card;
